import { HttpErrorResponse } from '@angular/common/http';
import { Component, Input } from '@angular/core';
import { IconoirEmptyPage, IconoirDownload } from '@ey-xd/motif-icon';
import { MotifButtonModule, MotifIconModule } from '@ey-xd/ng-motif';
import { FileManipulationService } from 'app/core/service/file-manipulation/file-manipulation.service';
import { ToastService } from 'app/core/service/toast/toast.service';
import { saveAs } from 'file-saver';

@Component({
  selector: 'app-custom-motif-downloader',
  standalone: true,
  imports: [MotifIconModule, MotifButtonModule],
  templateUrl: './custom-motif-downloader.component.html',
  styleUrl: './custom-motif-downloader.component.scss',
})
export class CustomMotifDownloaderComponent {
  // icons
  IconoirEmptyPage = IconoirEmptyPage;
  IconoirDownload = IconoirDownload;

  MAX_FILE_SIZE: number = 20 * 1024 * 1024; // 20MB

  private _fileId!: string;
  private _filename!: string;
  private _fileSize!: number;

  @Input()
  set fileId(value: string) {
    this._fileId = value;
  }
  @Input()
  set filename(value: string) {
    this._filename = value;
  }
  @Input()
  set fileSize(value: number) {
    this._fileSize = value;
  }

  get fileId(): string {
    return this._fileId;
  }
  get filename(): string {
    return this._filename;
  }
  get fileSize(): number {
    return this._fileSize;
  }

  constructor(
    private fileManipulationService: FileManipulationService,
    private toastService: ToastService
  ) {}

  ngOnInit() {
     if (this.filename.endsWith('.xlsb')) {
      this.filename = this.filename.replace(this.filename.slice(-5), ".xlsx")
    }
    if (this.filename.endsWith('.xlsm')) {
      this.filename = this.filename.replace(this.filename.slice(-5), ".xlsx")
    }
  }

  downloadExcelFile() {
    this.fileManipulationService.getDownloadFile(this.fileId).subscribe({
      next: (data: Blob) => {
        const nameFromApi: string = this.filename || 'Downloaded file';
        saveAs(data, nameFromApi);
      },
      error: (error: HttpErrorResponse) => {
        this.toastService.showHttpResponseErrorMessage(error);
      },
    });
  }

  bytesToMB(sizeInBytes: number): number {
    const sizeInMB = sizeInBytes / (1024 * 1024);
    return parseFloat(sizeInMB.toFixed(3));
  }
}
